module.exports = __webpack_public_path__ + "img/games-2.d781aef3.webp";